import React from "react"
import {Typography, Tooltip} from "@mui/material"
import InfoIcon from "@mui/icons-material/Info"
import useStyles from "./ToolTipLabelStyles"

interface TooltipLabelProps {
	toolTipHintText: string | React.ReactElement
	labelTitle: string
	children?: React.ReactNode
}

const TooltipLabel = (props: TooltipLabelProps) => {
	const {classes} = useStyles()
	return (
		<Tooltip title={props.toolTipHintText}>
			<div className={classes.tooltipContainer}>
				<Typography className={classes.label}>{props.labelTitle} </Typography>

				{props.children}
				<InfoIcon className={classes.infoIcon} color="disabled" />
			</div>
		</Tooltip>
	)
}

export default TooltipLabel
